import React from "react";
import { Modal as AntdModal } from "antd";
import classnames from "classnames";

import Icon from "_src/components/Icon";

import "./index.less";

const Modal = ({
  width = 732,
  scrollBar = false,
  visible,
  className,
  title,
  handleClose,
  handleAfterClose,
  ...props
}) => {
  return (
    <AntdModal
      afterClose={()=>{handleAfterClose && handleAfterClose() }}
      className={classnames("inft-modal", {
        "scrollBar": scrollBar,
      }, className)}
      centered
      footer={null}
      title={title}
      visible={visible}
      width={width}
      maskStyle={{ backdropFilter: 'blur(4px)' }}
      destroyOnClose={true}
      closeIcon={
        <Icon
          onClick={handleClose}
          type="icon-cancel"
          className="cancel-icon"
        />
      }
    >
      {props.children}
    </AntdModal>
  );
};

export default Modal;
